module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr10-83ddb01ff575a0d0371a48703f00185f.jpg";